import { aplicarMarcaBody } from "../utils/aplicarMarcaBody";
import { resolveBrand } from "../utils/brandsAdapter";
import { UseAdmin } from "./UseAdmin";
import { useBrandPreview } from "../context/BrandPreviewContext";

const MARCAS_SOPORTADAS = [
  "STARBUCKS",
  "BURGER KING",
  "CHILIS",
  "CHILI'S",
  "EL PORTÓN",
  "EL PORTON",
  "ITALIANNIS",
  "ITALIANNI'S",
  "P.F. CHANGS",
  "P.F.CHANG'S",
  "THE CHEESECAKE FACTORY",
  "VIPS",
  "DOMINOS PIZZA",
  "DOMINO'S PIZZA",
];

export const useColoresEmpresa = () => {
  const { brandfcNombre } = UseAdmin();
  const { previewBrand } = useBrandPreview();
  // const brandfcNombre = 'BURGER KING';
  // const brandfcNombre = MARCAS_SOPORTADAS[13];

  const currentBrand = resolveBrand(brandfcNombre);

  // console.log("BRANDING " + currentBrand);

  // Solo aplicar clases CSS si NO hay preview activo (para evitar sobrescribir el dropdown de testing)
  if (!previewBrand) {
    aplicarMarcaBody(currentBrand);
  }

  return currentBrand;
};
